// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BIpkXQxbWP55etL1iCTn .rprEF5J4ZF4qu1NGYGfd{padding:20px 24px}", "",{"version":3,"sources":["webpack://./src/components/Card.module.scss"],"names":[],"mappings":"AAAA,4CACE,iBAAA","sourcesContent":[".container .card {\n  padding: 20px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "BIpkXQxbWP55etL1iCTn",
	"card": "rprEF5J4ZF4qu1NGYGfd"
};
export default ___CSS_LOADER_EXPORT___;
